/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/display-name */
import React, { useCallback, useState } from 'react';
import Modal from 'react-responsive-modal';
import styled from 'styled-components';

import { translate } from '../../common/translation/translate';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { DataFetchSpinner } from '../common/dataFetchSpinner/dataFetchSpinner';

interface ShowRefreshPopup {
    open: boolean;
    closeRefreshPopup: () => void;
    setRefreshPopupFunctionality: () => void;
}

export const RefreshPopup = ({
    open = false,
    closeRefreshPopup,
    setRefreshPopupFunctionality
}: ShowRefreshPopup) => {
    const [ showUpdateText, setShowUpdateText ] = useState(true);

    const onCloseEvent = useCallback(() => {
        setRefreshPopupFunctionality();
        closeRefreshPopup();
    }, []);

    const reloadThePage = () => {
        setShowUpdateText(false);
        window.location.reload();
    };

    return (
        <Modal 
            open={open}
            styles={modalStyles}
            center={true} 
            onClose={onCloseEvent}>
            <ModalHeader>
                <Title>
                    {`${translate('refreshData')}`}
                </Title>
            </ModalHeader>
            <MessageContainer>
                
                <ReloadMessage>{`${translate('pleaseRefresh')}`}</ReloadMessage>
                <ButtonContainer>
                    <RefreshButton onClick={reloadThePage}>
                        {showUpdateText && <div>{`${translate('refresh')}`}</div>}
                        {!showUpdateText && <DataFetchSpinner width={18} height={18} strokeWidth={3}/>}
                    </RefreshButton>
                </ButtonContainer>
            </MessageContainer>
        </Modal>
    );
};

const modalStyles = {
    closeIcon: {
        fill: '#555555',
        width: 24,
        height: 24
    }
};

const ModalHeader = styled.h1`
    display: flex;
    flex-direction: row;
    background-color: #FFFFFF;
    padding: 10px 0 10px 20px;
`;

const Title = styled.div`
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 18px;
    font-weight: 600;
    align-items: center;
    color: #555555;
    padding: 10px 0 10px 5px;
    width: 80%;
    margin: 0;
    white-space: nowrap;
    text-transform: uppercase;
`;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #F9F9F9;
    color: #555555;
    font-family: Source Sans Pro;
    font-size: 16px;
    white-space: pre-wrap;
    padding-bottom: 20px;

    @media ${smallMediaQuery} {
        width: 100%;
    }
`;

const ReloadMessage = styled.div`
    margin: 25px;
`;

const ButtonContainer = styled.div`
    margin: 0 auto 10px 25px;
`;

const RefreshButton = styled.button`
    background-color: #0083C6;
    color: white;
    cursor: pointer;
    width: 81px;
    height: 36px;
    border-radius: 4px;
    text-transform: uppercase;
`;
